import React from "react"
import './styles/index.scss'
import './styles/fonts.scss'
import Container from "./container/Container"
import Footer from "./container/Footer"
import backgroundTheme from "./themes/backgroundTheme"

//edit app styles here
//edit colors and changes here
//call for update here, when you reload <Container?> 

class App extends React.Component {
  constructor(props){
    super(props);
    this.state={
      display: "container",
    }
  }


  render(){
    const appStyle = () => {
      let hour = new Date().getHours();
      let style;  
      for (const item of backgroundTheme){
        for (const colorHour of item.hour){
          if (hour === colorHour){
            style = item.style;
            }
          }
        }
      return style;
    }

    return (
      <div className="app" style={appStyle()}>
        <Container /> 
      </div>
    );
  } 
}

export default App
